<template>
  <div class="product-grid">
    <section class="widget">
      <h3 class="widget-title">
        Objetivo de publicidad: {{ info.title }}
        <Loading />
      </h3>
      <card>
        <div class="line-chart-section">
          <div class="line-chart-data">
            <div class="data" v-if="dataTotals.confirmed_calls">
              <p>Llamadas Confirmadas</p>
              <h1>{{ numberLetter(dataTotals.confirmed_calls) }}</h1>
            </div>
            <div class="data" v-if="info.name !== 'Alcance'">
              <p>{{ info.name }}</p>
              <h1>{{ numberLetter(results) }}</h1>
            </div>
            <div class="data">
              <p>Alcance</p>
              <h1>{{ numberLetter(dataTotals.reach || 0) }}</h1>
            </div>
            <div class="data">
              <p>Impresiones</p>
              <h1>{{ numberLetter(dataTotals.impressions || 0) }}</h1>
            </div>
          </div>
          <section class="widget">
            <ChartCustom
              :series="seriesData"
              :header="header"
              :label="info.name"
            />
          </section>
        </div>
      </card>
    </section>
  </div>
</template>
<script>
import ChartCustom from "./ChartCustom.vue";
const { numberLetter } = require("../../util");
import Loading from "./Loading.vue";
export default {
  name: "card-main",
  components: {
    ChartCustom,
    Loading
  },
  props: {
    series: Array,
    header: Array,
    totals: Object,
    info: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      dataTotals: {},
      results: 0,
      seriesData: undefined
    };
  },
  mounted() {
    this.seriesData = this.series;
    this.results = this.dataTotals.fresult;
  },
  methods: {
    numberLetter(d) {
      try {
        return numberLetter(d);
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    totals: {
      handler(total) {
        this.dataTotals = total;
      },
      deep: true
    },
    series: {
      handler(data) {
        if (data.length) {
          let results = 0;

          let d = [];
          d.push(data[0]);
          d.push({ name: this.info.name, data: data[1].data });

          for (let i in data[1].data) {
            results = results + parseInt(data[1].data[i]);
          }

          this.results = "" + results || "0";
          this.seriesData = d;
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.social-networks-wrapper {
  .line-chart-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .data {
      width: 100%;
      text-align: center;
      p {
        margin-bottom: 0;
      }
      h1 {
        color: $highlight-color;
        font-weight: $font-bold;
      }
    }
  }
  .facts {
    background: linear-gradient(96.6deg, #3c5a99 5.18%, #ed4b62 98.32%);
    padding: 40px;
    display: grid;
    grid-template-columns: 200px 1fr;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    align-items: center;
    margin-bottom: 20px;
    h2,
    p,
    li {
      color: #fff;
    }
    h2 {
      margin-bottom: 5px;
    }
    .left {
      padding-right: 20px;
      border-right: 3px solid #fff;
    }
    ul {
      padding-left: 40px;
      li {
        list-style-type: circle;
        margin-bottom: 5px;
      }
    }
  }
}

@include respond-above(sm) {
  .ad-data-copy {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .data {
      border-right: 1px solid #f1f2f3;
      padding: 0px 20px;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      &:last-child {
        border-right: 0px;
      }
    }
  }
  .line-chart-section {
    display: grid;
    grid-template-columns: 170px 1fr;
    column-gap: 20px;
  }
  .social-networks-wrapper {
    .line-chart-data {
      border-right: 1px solid $blueish-gray-200;
      .data {
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        &:nth-child(2) {
          border-top: 1px solid $blueish-gray-200;
          border-bottom: 1px solid $blueish-gray-200;
        }
      }
    }
  }
  .demographic-data {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    > h3.widget-title {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
  }
  .two-column {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    h3 {
      text-align: center;
    }
  }
}

.social-ad-preview {
  height: 485px;
  .el-carousel__container {
    min-height: 450px !important;
  }
}
</style>
